export default "__VITE_ASSET__r06a5jsW__"